import React from "react";

export const ZoomControl = ({ showFeatures }) => {
	return (
		<div id="zoom-control" className={`saas-billing-wrapper ${showFeatures ? "showing-features": ""}`}>
			<div className="billing-options-wrapper">
				<div className="left" style={{ width: "max-content" }}>
					<div
						className="option-block p-0"
						style={{
							width: "max-content",
							background: "none",
							border: "none",
						}}
					>
						<div
							className="block-body is-seats p-0"
							style={{ width: "max-content" }}
						>
							<div className="column p-0">
								<button id="zoom-control-in" className="add-seat ml-0">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width={24}
										height={24}
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth={2}
										strokeLinecap="round"
										strokeLinejoin="round"
										className="feather feather-plus"
									>
										<line x1={12} y1={5} x2={12} y2={19} />
										<line x1={5} y1={12} x2={19} y2={12} />
									</svg>
								</button>
								<button id="zoom-control-out" className="add-seat mt-1 ml-0">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width={24}
										height={24}
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										strokeWidth={2}
										strokeLinecap="round"
										strokeLinejoin="round"
										className="feather feather-minus"
									>
										<line x1={5} y1={12} x2={19} y2={12} />
									</svg>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
